import React from 'react'

const SpecialProducts = () => {
  return (
    <div>SpecialProducts</div>
  )
}

export default SpecialProducts;